var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveMedichalCheckup
    }
  }, [_vm._l(_vm.medical_checkup, function (state, index) {
    return _c('b-row', {
      key: index
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_vm.medical_checkup.length > 1 && index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-4 my-1 justify-content-end cursor-pointer position-absolute top-0",
      on: {
        "click": function click($event) {
          return _vm.deleteMedicalCheckupForm(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]) : _vm._e(), _c('b-form-group', {
      attrs: {
        "label": "Nomor / Name Document",
        "label-for": "document-number"
      }
    }, [_c('b-form-input', {
      attrs: {
        "plain": "",
        "id": "document-number",
        "name": "document-number",
        "placeholder": "Masukkan nomor / nama document"
      },
      model: {
        value: state.nama_document,
        callback: function callback($$v) {
          _vm.$set(state, "nama_document", $$v);
        },
        expression: "state.nama_document"
      }
    })], 1), _c('b-form-group', {
      attrs: {
        "label": "Attachment",
        "label-for": "attachment"
      }
    }, [_c('div', {
      staticClass: "custom-file"
    }, [_c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "id": "validatedCustomFile",
        "accept": ".pdf,.doc,.docx"
      },
      on: {
        "change": function change(event) {
          return _vm.prefiewFiles(event, state);
        }
      }
    }), !state.file ? _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v("Browse file...")]) : _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v(_vm._s(state.label_file))])]), _c('span', [_c('small', [_vm._v("Max File Size: 5 mb "), _c('br'), _vm._v("Type Allowed: .pdf, .jpg, .jpeg, .png, .docx, .doc, xlsx, xls")])])]), _c('b-form-group', {
      staticClass: "w-100",
      attrs: {
        "label": "Placed Issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Masukkan tempat diterbitkan",
        "plain": ""
      },
      model: {
        value: state.place_issued,
        callback: function callback($$v) {
          _vm.$set(state, "place_issued", $$v);
        },
        expression: "state.place_issued"
      }
    })], 1), _c('div', {
      staticClass: "d-flex"
    }, [_c('b-form-group', {
      staticClass: "w-50 mr-2",
      attrs: {
        "label": "Date Issued"
      }
    }, [_c('date-picker', {
      staticClass: "w-100",
      attrs: {
        "value-type": "YYYY-MM-DD"
      },
      model: {
        value: state.date_issued,
        callback: function callback($$v) {
          _vm.$set(state, "date_issued", $$v);
        },
        expression: "state.date_issued"
      }
    })], 1), _c('b-form-group', {
      staticClass: "w-50 mr-2",
      attrs: {
        "label": "Date Expired"
      }
    }, [_c('date-picker', {
      staticClass: "w-100",
      attrs: {
        "value-type": "YYYY-MM-DD"
      },
      model: {
        value: state.date_expired,
        callback: function callback($$v) {
          _vm.$set(state, "date_expired", $$v);
        },
        expression: "state.date_expired"
      }
    })], 1)], 1), _c('b-form-group', {
      staticClass: "w-100",
      attrs: {
        "label": "Notes"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.notesOption,
        "plain": ""
      },
      model: {
        value: state.notes,
        callback: function callback($$v) {
          _vm.$set(state, "notes", $$v);
        },
        expression: "state.notes"
      }
    })], 1), _c('b-form-group', {
      attrs: {
        "label": "Remarks",
        "label-for": "remarks"
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "id": "remarks",
        "name": "remarks",
        "rows": "3",
        "placeholder": "Masukan Remarks"
      },
      model: {
        value: state.remarks,
        callback: function callback($$v) {
          _vm.$set(state, "remarks", $$v);
        },
        expression: "state.remarks"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [index !== _vm.medical_checkup.length - 1 ? _c('hr') : _vm._e()])], 1);
  }), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMedicalCheckupForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM")])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": '6'
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('medical-checkup');
      }
    }
  }, [_vm._v("Close")])], 1), _c('b-col', {
    attrs: {
      "md": '6'
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "block": "",
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [!_vm.saving ? _c('i', {
    staticClass: "fa fa-file-signature"
  }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e()])], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }